import React from 'react';

import styled from 'styled-components';

const Image = styled.img`
  width: 100%;
  margin: ${({ theme }) => theme.spacing.medium}px auto
    ${({ theme }) => theme.spacing.large}px auto;
  display: block;
`;

const HowToMeasure: React.FC = () => {
  return (
    <Image src="/static/images/how_to_measure.png" alt="How to Measure Image" />
  );
};

export default HowToMeasure;
